import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800/50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-foreground-50 font-heading whitespace-nowrap">
                51视频
              </span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed">
              51视频提供高清免费影视内容，播放流畅不卡顿。涵盖电影、电视剧、综艺、动漫、纪录片、体育等多种类型，随时随地畅享观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-200 font-semibold text-sm mb-4 font-heading">视频分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-500 hover:text-primary-400 text-sm transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-200 font-semibold text-sm mb-4 font-heading">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors">
                  帮助中心
                </a>
              </li>
              <li>
                <a href="#" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-200 font-semibold text-sm mb-4 font-heading">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-mail-line text-primary-400"></i>
                <span>service@51video.com</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-5151</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>北京市朝阳区科技园区</span>
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-foreground-500 hover:text-primary-400 hover:bg-background-700 transition-colors">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-foreground-500 hover:text-primary-400 hover:bg-background-700 transition-colors">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-foreground-500 hover:text-primary-400 hover:bg-background-700 transition-colors">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-600 text-xs">
            &copy; 2026 51视频 版权所有 | 51视频在线高清免费观看不卡顿
          </p>
          <p className="text-foreground-600 text-xs">
            ICP备案号：京ICP备2024000001号
          </p>
        </div>
      </div>
    </footer>
  );
}